import cn from 'classnames';
import styles from './PrevNextButtonsEngine.scss';
import React from 'react';
import Prev from '../../../../Icons/Prev';
import Next from '../../../..//Icons/Next';

export default function CarModelEnginePrevNextButtons({ isOpen, onPrev, onNext }) {
  return (
    <>
      <button className={cn('button', 'button_prev', isOpen && 'button_show')} onClick={onPrev}>
        <Prev />
      </button>
      <button className={cn('button', 'button_next', isOpen && 'button_show')} onClick={onNext}>
        <Next />
      </button>
    </>
  );
}
